(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grandtech-blog-index"]) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-gt-blog-search]').forEach((form) => {
      if (form.dataset.initialized === 'true') return;
      form.dataset.initialized = 'true';
      form.addEventListener('submit', (event) => {
        const input = form.querySelector('[name="q"]');
        const term = input.value.trim().toLocaleLowerCase();
        if (!term) { input.value = '*'; return; }
        const match = Array.from(form.querySelectorAll('option[data-tag-url]')).find((option) => option.value.trim().toLocaleLowerCase() === term);
        if (!match) return;
        event.preventDefault();
        window.location.assign(match.dataset.tagUrl);
      });
    });

    scope.querySelectorAll('.gtblog__directory-panel').forEach((panel) => {
      if (panel.dataset.initialized === 'true') return;
      panel.dataset.initialized = 'true';
      panel.open = window.matchMedia('(min-width: 750px)').matches;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-commerce-header"]) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.productMenusReady) return;
    root.dataset.productMenusReady = 'true';
    const items = [...root.querySelectorAll('[data-gch-mega]')];
    const hover = window.matchMedia('(min-width: 851px) and (hover: hover)');
    const close = (item) => {
      item.querySelector('[data-gch-mega-toggle]').setAttribute('aria-expanded', 'false');
      item.querySelector('[data-gch-mega-menu]').hidden = true;
    };
    const open = (item) => {
      items.forEach(other => { if (other !== item) close(other); });
      root.querySelectorAll('.gch__nav details[open]').forEach(details => { details.open = false; });
      root.style.setProperty('--gch-mega-top', `${Math.max(0, root.getBoundingClientRect().bottom)}px`);
      item.querySelector('[data-gch-mega-toggle]').setAttribute('aria-expanded', 'true');
      item.querySelector('[data-gch-mega-menu]').hidden = false;
    };
    const activate = (item, tab) => {
      item.querySelectorAll('[data-gch-mega-tab]').forEach(button => {
        const selected = button === tab;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });
      item.querySelectorAll('[data-gch-mega-panel]').forEach(panel => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });
    };
    items.forEach(item => {
      const toggle = item.querySelector('[data-gch-mega-toggle]');
      let closeTimer;
      toggle.addEventListener('click', () => {
        if (toggle.getAttribute('aria-expanded') === 'true') close(item);
        else open(item);
      });
      item.addEventListener('pointerenter', () => {
        clearTimeout(closeTimer);
        if (hover.matches) open(item);
      });
      item.addEventListener('pointerleave', () => {
        if (hover.matches) closeTimer = setTimeout(() => close(item), 200);
      });
      item.addEventListener('focusout', () => {
        setTimeout(() => { if (!item.contains(document.activeElement)) close(item); }, 0);
      });
      item.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          close(item);
          toggle.focus();
        }
        if (event.target === toggle && event.key === 'ArrowDown') {
          event.preventDefault();
          open(item);
          item.querySelector('[data-gch-mega-tab][aria-selected=true]')?.focus();
        }
      });
      const tabs = [...item.querySelectorAll('[data-gch-mega-tab]')];
      tabs.forEach(tab => {
        tab.addEventListener('click', () => activate(item, tab));
        tab.addEventListener('pointerenter', () => { if (hover.matches) activate(item, tab); });
        tab.addEventListener('keydown', event => {
          if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let index = tabs.indexOf(tab);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = tabs.length - 1;
          else index = (index + (event.key === 'ArrowDown' ? 1 : -1) + tabs.length) % tabs.length;
          activate(item, tabs[index]);
          tabs[index].focus();
        });
      });
    });
    document.addEventListener('pointerdown', event => {
      items.forEach(item => { if (!item.contains(event.target)) close(item); });
    });
    window.addEventListener('resize', () => items.forEach(close));
    document.addEventListener('shopify:block:select', event => {
      const panel = event.target.closest('[data-gch-mega-panel]');
      if (!panel || !root.contains(panel)) return;
      const item = panel.closest('[data-gch-mega]');
      open(item);
      const tab = [...item.querySelectorAll('[data-gch-mega-tab]')].find(button => button.getAttribute('aria-controls') === panel.id);
      if (tab) activate(item, tab);
    });
  };
  document.querySelectorAll('[data-gch]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-gch]').forEach(initialize);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-contact-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('grandtech-managed-inquiry')) {
    customElements.define('grandtech-managed-inquiry', class extends HTMLElement {
      connectedCallback() {
        this.sync = () => {
          this.host = this.querySelector('[data-forms-id]');
          this.fallback = this.querySelector('[data-native-inquiry]');
          if (!this.host || !this.fallback) return;
          const root = this.host.querySelector('shopify-forms-embed')?.shadowRoot;
          if (root && root !== this.observedRoot) {
            this.shadowObserver?.disconnect();
            this.observedRoot = root;
            if (!root.querySelector('[data-grandtech-inquiry-layout]')) {
              const style = document.createElement('style');
              style.dataset.grandtechInquiryLayout = 'true';
              style.textContent = '[data-form-root] > div,[data-form-root] > div > div{display:block!important;width:100%!important}[data-form-root] section{height:auto!important;max-width:none!important;width:100%!important;align-content:start}[data-form-root]{--font-body-size:17px;--font-heading-size:26px;font-size:17px!important;line-height:1.7!important}[data-form-root] label,[data-form-root] input,[data-form-root] textarea,[data-form-root] select{font-size:17px!important;line-height:1.6!important}[data-form-root] p{font-size:16px!important;line-height:1.75!important}[data-form-root] button{font-size:18px!important;line-height:1.5!important;min-height:48px}';
              root.appendChild(style);
            }
            this.shadowObserver = new MutationObserver(this.sync);
            this.shadowObserver.observe(root, { childList: true, subtree: true });
          }
          if (root?.querySelector('form')) this.loaded = true;
          this.host.hidden = !this.loaded;
          this.fallback.hidden = !!this.loaded;
        };
        this.hostObserver = new MutationObserver(this.sync);
        this.hostObserver.observe(this, { childList: true, subtree: true });
        this.sync();
      }
      disconnectedCallback() {
        this.hostObserver?.disconnect();
        this.shadowObserver?.disconnect();
        this.observedRoot = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-customer-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grandtech-review-carousel')) {
  customElements.define('grandtech-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-review-track]');
      this.controls = this.querySelector('.gt-reviews__controls');
      this.toggle = this.querySelector('[data-review-toggle]');
      this.cards = [...this.track.children];
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.running = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.visible = false;
      this.interacting = false;
      this.focused = false;
      this.pointer = false;
      this.querySelector('[data-review-prev]').addEventListener('click',()=>this.move(-1),options);
      this.querySelector('[data-review-next]').addEventListener('click',()=>this.move(1),options);
      this.toggle.addEventListener('click',()=>{this.running=!this.running;this.refresh();},options);
      this.addEventListener('mouseenter',()=>{this.interacting=true;this.refresh();},options);
      this.addEventListener('mouseleave',()=>{this.interacting=false;this.refresh();},options);
      this.addEventListener('focusin',()=>{this.focused=true;this.refresh();},options);
      this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget)){this.focused=false;this.refresh();}},options);
      this.track.addEventListener('pointerdown',()=>{this.pointer=true;this.refresh();},options);
      window.addEventListener('pointerup',()=>{this.pointer=false;this.refresh();},options);
      window.addEventListener('pointercancel',()=>{this.pointer=false;this.refresh();},options);
      this.track.addEventListener('scroll',()=>{clearTimeout(this.scrollTimer);this.scrolling=true;this.refresh();this.scrollTimer=setTimeout(()=>{this.scrolling=false;this.refresh();},200);},{...options,passive:true});
      document.addEventListener('visibilitychange',()=>this.refresh(),options);
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.running=false;this.refresh();},options);
      document.addEventListener('shopify:block:select',event=>{if(this.contains(event.target)){this.running=false;const card=event.target.closest('.gt-reviews__card');if(card)this.go(card);this.refresh();}},options);
      this.resize = new ResizeObserver(()=>this.refresh());
      this.resize.observe(this.track);
      this.observer = new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.refresh();});
      this.observer.observe(this);
      this.track.hidden=this.cards.length===0;
      this.refresh();
    }
    go(card) {
      const distance=card.getBoundingClientRect().left-this.track.getBoundingClientRect().left;
      this.track.scrollBy({left:distance,behavior:this.motion.matches?'instant':'smooth'});
    }
    move(direction) {
      if (!this.cards.length) return;
      const left=this.track.getBoundingClientRect().left;
      let nearest=0;
      this.cards.forEach((card,index)=>{if(Math.abs(card.getBoundingClientRect().left-left)<Math.abs(this.cards[nearest].getBoundingClientRect().left-left))nearest=index;});
      const atEnd=this.cards[this.cards.length-1].getBoundingClientRect().right<=this.track.getBoundingClientRect().right+2;
      let next=nearest+direction;
      if(direction>0&&atEnd)next=0;
      if(next<0)next=this.cards.length-1;
      this.go(this.cards[next%this.cards.length]);
    }
    refresh() {
      clearTimeout(this.timer);
      const overflow=this.track.scrollWidth>this.track.clientWidth+2;
      this.controls.hidden=!overflow||this.dataset.showControls!=='true';
      this.toggle.hidden=this.dataset.autoplay!=='true';
      this.toggle.setAttribute('aria-label',this.running?this.toggle.dataset.pauseLabel:this.toggle.dataset.playLabel);
      this.toggle.firstElementChild.textContent=this.running?'Ⅱ':'▶';
      if(overflow&&this.running&&this.visible&&!document.hidden&&!this.interacting&&!this.focused&&!this.pointer&&!this.scrolling){
        this.timer=setTimeout(()=>{this.move(1);this.refresh();},Math.max(4000,Number(this.dataset.interval)||6000));
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.scrollTimer);
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-downloads-page"] && !Shopify.designMode) return;
  try {
    
  const initializeDownloads=()=>document.querySelectorAll('[data-download-center]').forEach(section=>{if(section.dataset.downloadSyncReady)return;section.dataset.downloadSyncReady='true';const buttons=[...section.querySelectorAll('[data-download-filter]')];const items=[...section.querySelectorAll('[data-download-item]')];const input=section.querySelector('[data-download-search]');const empty=section.querySelector('[data-download-empty]');let category='all';const update=()=>{const query=(input?.value||'').trim().toLowerCase();let visible=0;items.forEach(item=>{const show=(category==='all'||item.dataset.category===category)&&(!query||item.dataset.search.includes(query));item.hidden=!show;if(show)visible+=1});if(empty)empty.hidden=visible!==0};buttons.forEach(button=>button.addEventListener('click',()=>{category=button.dataset.downloadFilter;buttons.forEach(item=>item.classList.toggle('is-active',item===button));update()}));input?.addEventListener('input',update);update()});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeDownloads,{once:true});else initializeDownloads();
  document.addEventListener('shopify:section:load',initializeDownloads);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-faq-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('grandtech-faq')) {
    customElements.define('grandtech-faq', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.initialize(); });
      }
      initialize() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.input = this.querySelector('[data-faq-search]');
        if (!this.input) return;
        this.questions = [...this.querySelectorAll('[data-faq-question]')];
        this.groups = [...this.querySelectorAll('[data-faq-group]')];
        this.querySelector('[data-search-wrap]').hidden = false;
        this.normalize = value => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
        this.questions.forEach(question => { question.searchText = this.normalize(question.dataset.searchText); });
        this.filter = () => {
          const words = this.normalize(this.input.value.trim()).split(/\s+/).filter(Boolean);
          let count = 0;
          this.questions.forEach(question => {
            const visible = words.every(word => question.searchText.includes(word));
            question.hidden = !visible;
            if (visible) count++;
          });
          this.groups.forEach(group => {
            const visibleCount = group.querySelectorAll('[data-faq-question]:not([hidden])').length;
            group.hidden = visibleCount === 0;
            const link = [...this.querySelectorAll('[data-topic]')].find(topic => topic.dataset.topic === group.dataset.faqGroup);
            if (link) { link.hidden = !visibleCount; link.querySelector('.gtfaq__count').textContent = visibleCount; }
          });
          this.querySelector('[data-faq-empty]').hidden = count > 0;
          this.querySelector('[data-faq-clear]').hidden = words.length === 0;
          const status = this.querySelector('[data-faq-status]');
          status.textContent = status.dataset.resultMessage.replace('[count]', count);
        };
        this.input.addEventListener('input', this.filter, {signal});
        const reset = () => { this.input.value = ''; this.filter(); this.input.focus(); };
        this.querySelector('[data-faq-clear]').addEventListener('click', reset, {signal});
        this.querySelector('[data-faq-reset]').addEventListener('click', reset, {signal});
        this.querySelectorAll('[data-topic]').forEach(link => link.addEventListener('click', () => {
          this.querySelectorAll('[data-topic]').forEach(topic => topic.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'true');
        }, {signal}));
        this.filter();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change',event=>{if(event.target.matches('[data-gt-localization]'))event.target.form.submit()});

  const cropFooterLogos=(scope=document)=>{
    scope.querySelectorAll('[data-gt-footer-logo] img').forEach(visibleImage=>{
      if(visibleImage.dataset.gtCropReady)return;
      visibleImage.dataset.gtCropReady='true';
      const sourceImage=new Image();
      sourceImage.crossOrigin='anonymous';
      sourceImage.onload=()=>{
        try{
          const width=sourceImage.naturalWidth;
          const height=sourceImage.naturalHeight;
          if(!width||!height)return;
          const canvas=document.createElement('canvas');
          const scale=Math.min(1,1200/Math.max(width,height));
          canvas.width=Math.round(width*scale);
          canvas.height=Math.round(height*scale);
          const context=canvas.getContext('2d',{willReadFrequently:true});
          context.drawImage(sourceImage,0,0,canvas.width,canvas.height);
          const pixels=context.getImageData(0,0,canvas.width,canvas.height).data;
          const corners=[0,(canvas.width-1)*4,(canvas.height-1)*canvas.width*4,(canvas.width*canvas.height-1)*4];
          const transparent=corners.every(index=>pixels[index+3]<32);
          const background=[pixels[0],pixels[1],pixels[2]];
          const plainBackground=corners.every(index=>background.every((value,channel)=>Math.abs(value-pixels[index+channel])<24)&&pixels[index+3]>240);
          if(!transparent&&!plainBackground)return;
          let left=canvas.width,top=canvas.height,right=-1,bottom=-1;
          for(let y=0;y<canvas.height;y++){
            for(let x=0;x<canvas.width;x++){
              const index=(y*canvas.width+x)*4;
              const occupied=pixels[index+3]>24&&(transparent||background.some((value,channel)=>Math.abs(value-pixels[index+channel])>36));
              if(occupied){left=Math.min(left,x);top=Math.min(top,y);right=Math.max(right,x);bottom=Math.max(bottom,y)}
            }
          }
          if(right<left||bottom<top)return;
          const padding=Math.max(2,Math.round((right-left+1)*.012));
          left=Math.max(0,left-padding);top=Math.max(0,top-padding);
          right=Math.min(canvas.width-1,right+padding);bottom=Math.min(canvas.height-1,bottom+padding);
          const cropWidth=right-left+1,cropHeight=bottom-top+1;
          if(cropWidth<canvas.width*.15||cropHeight<2)return;
          const cropped=document.createElement('canvas');
          cropped.width=cropWidth;cropped.height=cropHeight;
          cropped.getContext('2d').drawImage(canvas,left,top,cropWidth,cropHeight,0,0,cropWidth,cropHeight);
          visibleImage.removeAttribute('srcset');
          visibleImage.removeAttribute('sizes');
          visibleImage.width=cropWidth;visibleImage.height=cropHeight;
          visibleImage.src=cropped.toDataURL('image/png');
        }catch{}
      };
      sourceImage.src=visibleImage.currentSrc||visibleImage.src;
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>cropFooterLogos(),{once:true});else cropFooterLogos();
  document.addEventListener('shopify:section:load',event=>cropFooterLogos(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-home-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grandtech-system-finder')) {
  class GrandtechSystemFinder extends HTMLElement {
    static selectedOptions = new Map();
    connectedCallback() {
      this.options = Array.from(this.querySelectorAll('[data-finder-option]'));
      this.results = Array.from(this.querySelectorAll('[data-finder-panel]'));
      this.images = Array.from(this.querySelectorAll('[data-finder-image]'));
      this.defaultImage = this.querySelector('[data-finder-default-image]');
      this.onClick = this.onClick || (event => {
        if (!(event.target instanceof Element)) return;
        const option = event.target.closest('[data-finder-option]');
        if (option && this.contains(option)) this.selectOption(option.dataset.finderOption);
      });
      this.onBlockSelect = this.onBlockSelect || (event => {
        const option = event.target instanceof Element ? event.target.closest('[data-finder-option]') : null;
        const id = option?.dataset.finderOption || event.detail?.blockId;
        if (id && this.options.some(button => button.dataset.finderOption === id)) this.selectOption(id);
      });
      this.addEventListener('click',this.onClick);
      this.addEventListener('shopify:block:select',this.onBlockSelect);
      const remembered = GrandtechSystemFinder.selectedOptions.get(this.dataset.finderSection);
      const initial = this.options.find(button => button.dataset.finderOption === remembered) || this.options[0];
      if (initial) this.selectOption(initial.dataset.finderOption);
    }
    disconnectedCallback() {
      this.removeEventListener('click',this.onClick);
      this.removeEventListener('shopify:block:select',this.onBlockSelect);
    }
    selectOption(id) {
      if (!this.options.some(button => button.dataset.finderOption === id)) return;
      GrandtechSystemFinder.selectedOptions.set(this.dataset.finderSection,id);
      this.options.forEach(button => {
        const selected = button.dataset.finderOption === id;
        button.classList.toggle('is-active',selected);
        button.setAttribute('aria-pressed',String(selected));
      });
      this.results.forEach(panel => { panel.hidden = panel.dataset.finderPanel !== id; });
      const selectedImage = this.images.find(frame => frame.dataset.finderImage === id);
      if (selectedImage && !selectedImage.querySelector('img')) {
        const template = selectedImage.querySelector('[data-finder-image-template]');
        if (template) selectedImage.append(template.content.cloneNode(true));
      }
      this.images.forEach(frame => { frame.hidden = frame !== selectedImage; });
      if (this.defaultImage) this.defaultImage.hidden = Boolean(selectedImage);
    }
  }
  customElements.define('grandtech-system-finder',GrandtechSystemFinder);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-home-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('grandtech-motion-hero')) {
  class GrandtechMotionHero extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.gth-motion-hero');
      this.media = this.querySelector('.gth-motion-hero__media');
      if (!this.panel || !this.media) return;
      this.disposed = false;
      this.inView = true;
      this.viewport = window.matchMedia('(max-width: 749px)');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.syncPlayback = () => {
        if (!this.video || this.disposed) return;
        if (this.inView && !document.hidden && !this.motion.matches && this.dataset.autoplay !== 'false') {
          this.video.muted = true;
          this.video.play().catch(() => this.panel.classList.add('is-paused'));
        } else this.video.pause();
      };
      this.onFrame = () => this.panel.classList.add('has-frame');
      this.onError = () => this.panel.classList.add('has-error');
      this.onState = () => this.panel.classList.toggle('is-paused', !this.video || this.video.paused);
      this.selectMedia = () => {
        if (this.dataset.mediaMode && this.dataset.mediaMode !== 'video') return;
        const kind = this.viewport.matches ? 'mobile' : 'desktop';
        if (kind === this.kind) return;
        const template = this.querySelector('[data-gth-' + kind + '-media]');
        if (!template) return;
        this.releaseVideo();
        this.kind = kind;
        this.panel.classList.remove('has-frame', 'has-error');
        this.media.replaceChildren(template.content.cloneNode(true));
        this.video = this.media.querySelector('video');
        if (!this.video) return;
        this.video.muted = this.video.defaultMuted = this.video.loop = this.video.playsInline = true;
        this.video.addEventListener('loadeddata', this.onFrame);
        this.video.addEventListener('error', this.onError);
        this.video.addEventListener('play', this.onState);
        this.video.addEventListener('pause', this.onState);
        if (this.video.readyState >= 2) this.onFrame();
        this.syncPlayback();
      };
      this.viewport.addEventListener('change', this.selectMedia);
      this.motion.addEventListener('change', this.syncPlayback);
      document.addEventListener('visibilitychange', this.syncPlayback);
      document.addEventListener('pointerdown', this.syncPlayback, {passive: true});
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPlayback();
        }, {threshold: .1});
        this.observer.observe(this.panel);
      }
      this.selectMedia();
    }
    releaseVideo() {
      if (!this.video) return;
      this.video.pause();
      this.video.removeEventListener('loadeddata', this.onFrame);
      this.video.removeEventListener('error', this.onError);
      this.video.removeEventListener('play', this.onState);
      this.video.removeEventListener('pause', this.onState);
      this.video.removeAttribute('src');
      this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
      this.video.load();
      this.video = null;
    }
    disconnectedCallback() {
      this.disposed = true;
      this.releaseVideo();
      this.observer?.disconnect();
      this.viewport?.removeEventListener('change', this.selectMedia);
      this.motion?.removeEventListener('change', this.syncPlayback);
      document.removeEventListener('visibilitychange', this.syncPlayback);
      document.removeEventListener('pointerdown', this.syncPlayback);
      this.kind = null;
    }
  }
  customElements.define('grandtech-motion-hero', GrandtechMotionHero);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-home-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grandtech-home-video-rail')) {
  class GrandtechHomeVideoRail extends HTMLElement {
    static openRails = new Set();
    connectedCallback() {
      this.track = this.querySelector('[data-video-track]');
      this.cards = Array.from(this.querySelectorAll('[data-video-card]'));
      this.dialog = this.querySelector('[data-gtv-dialog]');
      this.player = this.querySelector('[data-gtv-player]');
      this.onClick = this.onClick || this.handleClick.bind(this);
      this.onClose = this.onClose || this.cleanPlayer.bind(this);
      this.onVisible = this.onVisible || (() => this.startTimer());
      this.onPause = this.onPause || (() => this.stopTimer());
      this.onResume = this.onResume || (() => this.startTimer());
      this.addEventListener('click',this.onClick);
      this.dialog.addEventListener('close',this.onClose);
      document.addEventListener('visibilitychange',this.onVisible);
      this.addEventListener('pointerenter',this.onPause);
      this.addEventListener('pointerleave',this.onResume);
      this.addEventListener('focusin',this.onPause);
      this.addEventListener('focusout',this.onResume);
      this.querySelectorAll('[data-video-play]').forEach(button => { button.hidden = false; });
      this.querySelectorAll('[data-video-prev],[data-video-next]').forEach(button => { button.hidden = this.cards.length < 2; });
      this.startTimer();
    }
    disconnectedCallback() {
      this.tearingDown = true;
      this.stopTimer();
      if (this.dialog.open) this.dialog.close();
      this.cleanPlayer();
      this.removeEventListener('click',this.onClick);
      this.dialog.removeEventListener('close',this.onClose);
      document.removeEventListener('visibilitychange',this.onVisible);
      this.removeEventListener('pointerenter',this.onPause);
      this.removeEventListener('pointerleave',this.onResume);
      this.removeEventListener('focusin',this.onPause);
      this.removeEventListener('focusout',this.onResume);
      this.tearingDown = false;
    }
    startTimer() {
      this.stopTimer();
      if (this.tearingDown || this.cards.length < 2 || this.dataset.autoScroll !== 'true' || document.hidden || this.dialog.open || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => this.move(1),Math.max(3,Number(this.dataset.interval)||5)*1000);
    }
    stopTimer() { if(this.timer) clearInterval(this.timer); this.timer = null; }
    move(direction) {
      if (!this.track || this.cards.length < 2) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap)||0;
      const step = this.cards[0].getBoundingClientRect().width + gap;
      let left = this.track.scrollLeft + step * direction;
      if (direction > 0 && this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 8) left = 0;
      if (direction < 0 && this.track.scrollLeft <= 8) left = this.track.scrollWidth;
      this.track.scrollTo({left,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    handleClick(event) {
      if (!(event.target instanceof Element)) return;
      const play = event.target.closest('[data-video-play]');
      if (play && this.contains(play)) {
        if (this.dialog.open || !play.dataset.videoSrc) return;
        this.stopTimer();
        this.activeTrigger = play;
        this.querySelector('[data-gtv-title]').textContent = play.dataset.videoTitle;
        const frame = document.createElement('iframe');
        frame.title = play.dataset.videoTitle;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        this.player.replaceChildren(frame);
        this.dialog.showModal();
        GrandtechHomeVideoRail.openRails.add(this);
        this.syncScrollLock();
        frame.src = play.dataset.videoSrc;
        return;
      }
      const close = event.target.closest('[data-gtv-close]');
      if (close && this.contains(close)) { this.dialog.close(); return; }
      const previous = event.target.closest('[data-video-prev]');
      if (previous && this.contains(previous)) { this.move(-1); this.startTimer(); return; }
      const next = event.target.closest('[data-video-next]');
      if (next && this.contains(next)) { this.move(1); this.startTimer(); return; }
      if (event.target === this.dialog) {
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }
    }
    syncScrollLock() { document.documentElement.classList.toggle('gtv-dialog-open',GrandtechHomeVideoRail.openRails.size > 0); }
    cleanPlayer() {
      this.player.replaceChildren();
      GrandtechHomeVideoRail.openRails.delete(this);
      this.syncScrollLock();
      const trigger = this.activeTrigger;
      this.activeTrigger = null;
      if (!this.tearingDown && trigger?.isConnected) trigger.focus({preventScroll:true});
      this.startTimer();
    }
  }
  customElements.define('grandtech-home-video-rail',GrandtechHomeVideoRail);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection-sort]').forEach(select=>select.addEventListener('change',()=>{const url=new URL(window.location.href);url.searchParams.set('sort_by',select.value);window.location.assign(url.toString())}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-main-product"] && !Shopify.designMode) return;
  try {
    
  const showGrandtechProductMedia=(section,mediaId)=>{
    const view=section?.querySelector('[data-product-media-view]');
    if(!view||!mediaId)return;
    if(view.dataset.mediaId===mediaId&&!view.querySelector('[data-product-media-play]'))return;
    const source=[...section.querySelectorAll('template[data-product-media-template]')].find(item=>item.dataset.productMediaTemplate===mediaId);
    if(!source)return;
    view.querySelectorAll('video').forEach(video=>video.pause());
    view.replaceChildren(source.content.cloneNode(true));
    view.dataset.mediaId=mediaId;
    view.dataset.mediaType=source.dataset.mediaType;
    const video=view.querySelector('video');
    if(video){
      const playback=video.play();
      if(playback)playback.catch(()=>{});
      video.focus();
    }else{
      view.querySelector('iframe')?.focus();
    }
    section.querySelectorAll('[data-product-media-thumb]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.productMediaThumb===mediaId)));
  };
  document.addEventListener('click',event=>{
    const playButton=event.target.closest('[data-product-media-play]');
    if(playButton){
      showGrandtechProductMedia(playButton.closest('[data-gt-product]'),playButton.dataset.productMediaPlay);
      return;
    }
    const button=event.target.closest('[data-product-media-thumb]');
    if(button)showGrandtechProductMedia(button.closest('[data-gt-product]'),button.dataset.productMediaThumb);
  });

const initializeGrandtechVariantButtons = section => {
  const form = section.querySelector('form[action*="/cart/add"]');
  const getVariantInput = () => form?.querySelector('[name="id"]:checked') || form?.querySelector('input[type="hidden"][name="id"]');
  const picker = section.querySelector('[data-variant-picker]');
  const submit = section.querySelector('[data-product-submit]');
  const buyNow = section.querySelector('[data-buy-now]');
  const setAvailability = available => {
    if (submit) {
      submit.disabled = !available;
      submit.textContent = available ? section.dataset.addLabel : section.dataset.soldLabel;
    }
    if (buyNow) buyNow.disabled = !available;
  };
  picker?.addEventListener('change', event => {
    const input = event.target.closest('[data-product-variant]');
    if (!input || !input.checked) return;
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-product-compare]');
    const sku = section.querySelector('[data-product-sku]');
    if (price) price.textContent = input.dataset.price || '';
    if (compare) {
      compare.textContent = input.dataset.compare || '';
      compare.hidden = !input.dataset.compare;
    }
    if (sku) sku.textContent = input.dataset.sku || '';
    showGrandtechProductMedia(section, input.dataset.mediaId);
    setAvailability(input.dataset.available === 'true');
    const url = new URL(window.location.href);
    url.searchParams.set('variant', input.value);
    window.history.replaceState(window.history.state, '', url);
  });
  const initialInput = getVariantInput();
  if (form && initialInput && !initialInput.value && section.dataset.productJsonUrl) {
    fetch(section.dataset.productJsonUrl, {headers:{Accept:'application/json'}})
      .then(response => response.ok ? response.json() : Promise.reject())
      .then(data => {
        const requested = new URLSearchParams(window.location.search).get('variant');
        const variant = data.variants.find(item => String(item.id) === requested) || data.variants.find(item => item.available) || data.variants[0];
        if (variant) {
          initialInput.value = variant.id;
          setAvailability(Boolean(variant.available));
        }
      }).catch(() => setAvailability(false));
  }
  buyNow?.addEventListener('click', async () => {
    if (!form || !getVariantInput()?.value || buyNow.disabled) return;
    buyNow.disabled = true;
    try {
      const response = await fetch(section.dataset.cartUrl, {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if (!response.ok) throw new Error('Unable to add product');
      window.location.assign(section.dataset.checkoutUrl);
    } catch (error) {
      if (submit) form.requestSubmit(submit);
    } finally {
      buyNow.disabled = getVariantInput()?.dataset.available === 'false';
    }
  });
};
document.querySelectorAll('[data-gt-product]').forEach(section => {
  initializeGrandtechVariantButtons(section);
  const details = section.querySelector('.gtpd-description .rte');
  if (!details) return;
  const specificationHeading = Array.from(details.querySelectorAll('h2,h3,h4')).find(heading => /specification|parameter|technical data/i.test(heading.textContent || ''));
  const specificationTarget = specificationHeading || details.querySelector('table') || details;
  specificationTarget.id = 'product-specifications';
});

  document.querySelectorAll('[data-gt-product]').forEach(section=>{const quantity=section.querySelector('[data-quantity-input]');const updateQuantity=change=>{if(!quantity)return;const minimum=Number(quantity.min)||1;const current=Number(quantity.value)||minimum;quantity.value=Math.max(minimum,current+change);quantity.dispatchEvent(new Event('change',{bubbles:true}))};section.querySelector('[data-quantity-minus]')?.addEventListener('click',()=>updateQuantity(-1));section.querySelector('[data-quantity-plus]')?.addEventListener('click',()=>updateQuantity(1))});
  document.querySelectorAll('[data-delivery-checker]').forEach(checker=>{const postal=checker.querySelector('[data-delivery-postal]');const button=checker.querySelector('[data-delivery-check]');const result=checker.querySelector('[data-delivery-result]');const check=()=>{if(!postal||!result)return;const zip=postal.value.trim();if(!/^\d{5}(-\d{4})?$/.test(zip)){result.textContent=checker.dataset.invalidMessage||'';result.classList.add('is-error');postal.setAttribute('aria-invalid','true');return}const first=Number(zip.charAt(0));const days=first<=3?checker.dataset.eastDays:first<=7?checker.dataset.centralDays:checker.dataset.westDays;result.textContent=`${checker.dataset.resultPrefix||''} ${days||''}`.trim();result.classList.remove('is-error');postal.removeAttribute('aria-invalid')};button?.addEventListener('click',check);postal?.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();check()}})});
if (!customElements.get('grandtech-product-tabs')) {
  customElements.define('grandtech-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('.gtpd-tabs');
      if (!this.nav) return;
      this.header = document.querySelector('.gch')?.closest('.shopify-section') || document.querySelector('.gch');
      this.footer = document.querySelector('.gt-footer');
      this.abort = new AbortController();
      const options = {signal:this.abort.signal,passive:true};
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {this.frame=0;this.update();});
      };
      window.addEventListener('scroll',this.schedule,options);
      window.addEventListener('resize',this.schedule,options);
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this.nav);
      if (this.header) this.resize.observe(this.header);
      this.update();
    }
    update() {
      if (!this.isConnected) return;
      const top = Math.max(0,this.header?.getBoundingClientRect().bottom || 0);
      const rect = this.getBoundingClientRect();
      const height = this.nav.getBoundingClientRect().height;
      const footerTop = this.footer?.getBoundingClientRect().top ?? Infinity;
      const fixed = rect.top <= top && footerTop > top + height;
      this.nav.style.setProperty('--gt-tabs-top',`${top}px`);
      this.nav.style.setProperty('--gt-tabs-left',`${rect.left}px`);
      this.nav.style.setProperty('--gt-tabs-width',`${rect.width}px`);
      document.documentElement.style.setProperty('--gt-product-scroll-offset',`${top+height+20}px`);
      this.style.height = fixed ? `${height}px` : '';
      this.nav.classList.toggle('is-fixed',fixed);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame=0;
      this.nav?.classList.remove('is-fixed');
      this.style.height='';
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-marketplace-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded',()=>{const buttons=document.querySelectorAll('.gm-options button');const result=document.querySelector('[data-gm-result]');buttons.forEach(button=>button.addEventListener('click',()=>{buttons.forEach(item=>item.classList.remove('is-active'));button.classList.add('is-active');if(result)result.textContent=button.dataset.result||''}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.gtr[data-url]').forEach(section=>{const observer=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)return;observer.disconnect();fetch(section.dataset.url).then(response=>response.text()).then(text=>{const html=document.createElement('div');html.innerHTML=text;const replacement=html.querySelector('.gtr');if(replacement&&replacement.innerHTML.trim())section.innerHTML=replacement.innerHTML}).catch(()=>{})},{rootMargin:'0px 0px 300px 0px'});observer.observe(section)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-subscription-gate"]) return;
  try {
    
if (!customElements.get('grandtech-subscription-gate')) {
  customElements.define('grandtech-subscription-gate', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.result = this.querySelector('[data-gate-result]')?.dataset.gateResult;
      this.accessKey = this.dataset.storageKey;
      this.pendingKey = this.dataset.pendingKey;
      this.skipKey = this.dataset.skipKey;
      this.allowSkip = this.dataset.allowSkip === 'true';
      this.editor = this.dataset.editor === 'true';
      this.onlyFirst = this.dataset.onceOnly === 'true' && this.allowSkip;
      this.seenKey = this.dataset.seenKey;
      const previewUrl = new URL(location.href);
      if (previewUrl.searchParams.has('gt_subscription_preview')) {
        previewUrl.searchParams.delete('gt_subscription_preview');
        history.replaceState(history.state, '', previewUrl.href);
      }
      this.videos = Array.from(this.querySelectorAll('video'));
      this.videoToggle = this.querySelector('[data-video-toggle]');
      this.storageListener = (event) => {
        if (event.key === this.accessKey && this.valid(this.accessKey)) this.closeGate();
        if (this.allowSkip && event.key === this.skipKey && this.valid(this.skipKey)) this.closeGate();
        if (this.onlyFirst && event.key === this.seenKey && this.hasSeen() && !this.valid(this.pendingKey, true)) this.closeGate();
      };
      window.addEventListener('storage', this.storageListener);
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        if (this.allowSkip) this.skip();
      });
      this.querySelector('[data-editor-close]')?.addEventListener('click', () => this.closeGate());
      this.querySelectorAll('[data-skip-subscription]').forEach((button) => button.addEventListener('click', () => this.skip()));
      const pendingSubmission = this.valid(this.pendingKey, true);
      if (this.result === 'success' && pendingSubmission) {
        this.grant();
        return;
      }
      if (this.valid(this.accessKey) || this.allowSkip && this.valid(this.skipKey)) {
        this.markSeen();
        this.closeGate();
        return;
      }
      if (this.hasSeen() && !pendingSubmission) {
        this.closeGate();
        return;
      }
      if (this.result === 'success') {
        const status = this.querySelector('[data-gate-success]');
        if (status) status.hidden = true;
      }
      if (this.result === 'error') this.remove(this.pendingKey, true);
      this.form?.addEventListener('submit', () => {
        if (!this.form.checkValidity()) return;
        this.write(this.pendingKey, Date.now() + 30 * 60 * 1000, true);
        this.form.setAttribute('aria-busy', 'true');
      });
      document.body.classList.add('gt-subscription-locked');
      if (this.dialog.open) this.dialog.close();
      this.dialog.showModal();
      this.markSeen();
      this.setupVideo();
      requestAnimationFrame(() => this.querySelector('input[type="email"]')?.focus());
    }
    disconnectedCallback() {
      window.removeEventListener('storage', this.storageListener);
      if (this.mediaListener) this.mobileQuery?.removeEventListener('change', this.mediaListener);
      if (this.motionListener) this.motionQuery?.removeEventListener('change', this.motionListener);
      this.pauseVideos();
      document.body.classList.remove('gt-subscription-locked');
    }
    hasSeen() {
      if (!this.onlyFirst) return false;
      try {
        if (window.localStorage.getItem(this.seenKey) === '1') return true;
      } catch {}
      return document.cookie.split(';').some((part) => part.trim() === this.seenKey + '=1');
    }
    markSeen() {
      if (!this.onlyFirst) return;
      try {
        window.localStorage.setItem(this.seenKey, '1');
      } catch {}
      document.cookie = this.seenKey + '=1; Path=/; Max-Age=31536000; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    }
    valid(key, session = false) {
      try {
        const storage = session ? window.sessionStorage : window.localStorage;
        const expiry = Number(storage.getItem(key));
        if (Number.isFinite(expiry) && expiry > Date.now()) return true;
      } catch {}
      const pair = document.cookie.split(';').map((part) => part.trim()).find((part) => part.startsWith(key + '='));
      const expiry = Number(pair?.slice(key.length + 1));
      return Number.isFinite(expiry) && expiry > Date.now();
    }
    write(key, expiry, session = false) {
      try {
        const storage = session ? window.sessionStorage : window.localStorage;
        storage.setItem(key, String(expiry));
      } catch {}
      const seconds = Math.max(1, Math.ceil((expiry - Date.now()) / 1000));
      document.cookie = key + '=' + expiry + '; Path=/; Max-Age=' + seconds + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    }
    remove(key, session = false) {
      try {
        const storage = session ? window.sessionStorage : window.localStorage;
        storage.removeItem(key);
      } catch {}
      document.cookie = key + '=; Path=/; Max-Age=0; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    }
    rememberUntil() {
      const days = Math.min(90, Math.max(1, Number(this.dataset.memoryDays) || 30));
      return Date.now() + days * 86400000;
    }
    grant() {
      this.markSeen();
      this.write(this.accessKey, this.rememberUntil());
      this.remove(this.pendingKey, true);
      this.remove(this.skipKey);
      this.closeGate();
      const url = new URL(location.href);
      url.searchParams.delete('customer_posted');
      if (url.hash === '#' + this.form.id) url.hash = '';
      history.replaceState(history.state, '', url.href);
    }
    skip() {
      if (!this.allowSkip) return;
      this.markSeen();
      this.write(this.skipKey, this.rememberUntil());
      this.remove(this.pendingKey, true);
      this.closeGate();
    }
    setupVideo() {
      if (!this.videos.length) return;
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPaused = this.motionQuery.matches;
      this.mediaListener = () => this.updateVideo();
      this.motionListener = (event) => {
        if (event.matches) this.manualPaused = true;
        this.updateVideo();
      };
      this.mobileQuery.addEventListener('change', this.mediaListener);
      this.motionQuery.addEventListener('change', this.motionListener);
      this.videoToggle?.addEventListener('click', () => {
        this.manualPaused = !this.manualPaused;
        this.updateVideo();
      });
      this.updateVideo();
    }
    updateVideo() {
      const mobile = this.querySelector('.gtgate__video--mobile');
      const desktop = this.querySelector('.gtgate__video--desktop');
      const active = this.mobileQuery.matches && mobile ? mobile : desktop || mobile;
      this.videos.forEach((video) => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        if (video !== active || this.manualPaused || this.hidden || !this.dialog.open) video.pause();
      });
      if (active && !this.manualPaused && !this.hidden && this.dialog.open) {
        try {
          const playback = active.play();
          playback?.catch(() => {
            this.manualPaused = true;
            this.updateVideoButton();
          });
        } catch {
          this.manualPaused = true;
        }
      }
      this.updateVideoButton();
    }
    updateVideoButton() {
      if (!this.videoToggle) return;
      this.videoToggle.textContent = this.manualPaused ? this.videoToggle.dataset.playLabel : this.videoToggle.dataset.pauseLabel;
      this.videoToggle.setAttribute('aria-pressed', String(this.manualPaused));
    }
    pauseVideos() {
      this.videos?.forEach((video) => video.pause());
    }
    closeGate() {
      this.pauseVideos();
      if (this.dialog.open) this.dialog.close();
      this.hidden = true;
      document.body.classList.remove('gt-subscription-locked');
      document.getElementById('MainContent')?.focus({ preventScroll: true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grandtech-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grandtech-video-library')) {
  class GrandtechVideoLibrary extends HTMLElement {
    static openLibraries = new Set();
    normalize(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLocaleLowerCase(); }
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-gtvideos-card]'));
      this.filters = Array.from(this.querySelectorAll('[data-gtvideos-filter]'));
      this.search = this.querySelector('[data-gtvideos-search]');
      this.dialog = this.querySelector('[data-gtvideos-dialog]');
      this.body = this.querySelector('[data-gtvideos-body]');
      this.activeCategory = '';
      const categories = new Set(this.cards.map(card => this.normalize(card.dataset.videoCategory)));
      const seen = new Set();
      this.filters.forEach(button => {
        const category = this.normalize(button.dataset.gtvideosFilter);
        button.hidden = !!category && (!categories.has(category) || seen.has(category));
        seen.add(category);
      });
      this.onClick = this.onClick || this.handleClick.bind(this);
      this.onInput = this.onInput || (() => this.applyFilters());
      this.onClose = this.onClose || this.cleanPlayer.bind(this);
      this.addEventListener('click',this.onClick);
      this.addEventListener('input',this.onInput);
      this.dialog.addEventListener('close',this.onClose);
      this.querySelector('[data-gtvideos-tools]').hidden = false;
      this.querySelector('[data-gtvideos-count]').hidden = false;
      this.querySelectorAll('[data-gtvideos-open]').forEach(button => { button.hidden = false; });
      this.applyFilters();
    }
    disconnectedCallback() {
      this.tearingDown = true;
      if (this.dialog.open) this.dialog.close();
      this.cleanPlayer();
      this.removeEventListener('click',this.onClick);
      this.removeEventListener('input',this.onInput);
      this.dialog.removeEventListener('close',this.onClose);
      this.tearingDown = false;
    }
    applyFilters() {
      const query = this.normalize(this.search.value);
      let count = 0;
      this.cards.forEach(card => {
        const categoryMatches = !this.activeCategory || this.normalize(card.dataset.videoCategory) === this.activeCategory;
        const queryMatches = !query || this.normalize(card.dataset.videoSearch).includes(query);
        card.hidden = !(categoryMatches && queryMatches);
        if (!card.hidden) count++;
      });
      this.filters.forEach(button => {
        const selected = this.normalize(button.dataset.gtvideosFilter) === this.activeCategory;
        button.setAttribute('aria-pressed', String(selected));
        button.classList.toggle('is-active',selected);
      });
      const status = this.querySelector('[data-gtvideos-count]');
      status.textContent = status.dataset.countTemplate.replace('[count]',String(count));
      this.querySelector('[data-gtvideos-empty]').hidden = count !== 0;
    }
    handleClick(event) {
      if (!(event.target instanceof Element)) return;
      const filter = event.target.closest('[data-gtvideos-filter]');
      if (filter && this.contains(filter)) { this.activeCategory = this.normalize(filter.dataset.gtvideosFilter); this.applyFilters(); return; }
      const reset = event.target.closest('[data-gtvideos-reset]');
      if (reset && this.contains(reset)) { this.activeCategory = ''; this.search.value = ''; this.applyFilters(); this.search.focus({preventScroll:true}); return; }
      const open = event.target.closest('[data-gtvideos-open]');
      if (open && this.contains(open)) {
        if (this.dialog.open) return;
        const card = open.closest('[data-gtvideos-card]');
        const content = card.querySelector('template[data-gtvideos-content]');
        if (!content) return;
        this.body.replaceChildren(content.content.cloneNode(true));
        this.querySelector('[data-gtvideos-title]').textContent = card.dataset.videoTitle;
        this.activeTrigger = open;
        this.dialog.showModal();
        GrandtechVideoLibrary.openLibraries.add(this);
        this.syncScrollLock();
        const frame = this.body.querySelector('[data-gtvideos-frame]');
        if (frame) frame.src = frame.dataset.src;
        const video = this.body.querySelector('video');
        if (video) video.play().catch(() => {});
        return;
      }
      const close = event.target.closest('[data-gtvideos-close]');
      if (close && this.contains(close)) { this.dialog.close(); return; }
      if (event.target === this.dialog) {
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }
    }
    syncScrollLock() { document.documentElement.classList.toggle('gtvideo-dialog-open',GrandtechVideoLibrary.openLibraries.size > 0); }
    cleanPlayer() {
      this.body.querySelectorAll('video').forEach(video => video.pause());
      this.body.replaceChildren();
      GrandtechVideoLibrary.openLibraries.delete(this);
      this.syncScrollLock();
      const trigger = this.activeTrigger;
      this.activeTrigger = null;
      if (!this.tearingDown && trigger?.isConnected) trigger.focus({preventScroll:true});
    }
  }
  customElements.define('grandtech-video-library',GrandtechVideoLibrary);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-gt-other-articles]').forEach((panel) => {
      if (panel.dataset.initialized) return;
      panel.dataset.initialized = 'true';
      panel.open = window.matchMedia('(min-width: 990px)').matches;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-gt-blog-search]').forEach((form) => {
      if (form.dataset.initialized === 'true') return;
      form.dataset.initialized = 'true';
      form.addEventListener('submit', (event) => {
        const input = form.querySelector('[name="q"]');
        const term = input.value.trim().toLocaleLowerCase();
        if (!term) { input.value = '*'; return; }
        const match = Array.from(form.querySelectorAll('option[data-tag-url]')).find((option) => option.value.trim().toLocaleLowerCase() === term);
        if (!match) return;
        event.preventDefault();
        window.location.assign(match.dataset.tagUrl);
      });
    });

    scope.querySelectorAll('.gtblog__directory-panel').forEach((panel) => {
      if (panel.dataset.initialized === 'true') return;
      panel.dataset.initialized = 'true';
      panel.open = window.matchMedia('(min-width: 750px)').matches;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  function compute(input, config, options) {
    const positive = v => Number.isFinite(v) && v > 0;
    if (![input.usage,input.sun,input.hours,config.panelWatts,config.performance,config.usable,config.discharge,config.ratio].every(positive) || config.performance > 100 || config.usable > 100 || config.discharge > 100 || !Number.isFinite(config.offgridReserve) || config.offgridReserve < 0) throw new Error('config');
    const daily = input.usage * 12 / 365;
    const share = input.system === 'offgrid' ? 1 : ({essential:.25,partial:.5,whole:1}[input.backup]);
    const pvTarget = daily / input.sun / (config.performance / 100) * (input.system === 'offgrid' ? 1 + config.offgridReserve / 100 : 1);
    const compatible = options.filter(p => p[input.system] && positive(p.capacity));
    const panel = compatible.find(p => p.category === 'panel') || null;
    const watts = panel ? panel.capacity : config.panelWatts;
    const panels = Math.ceil(pvTarget * 1000 / watts);
    const pv = panels * watts / 1000;
    const peak = input.peak || Math.max(2,daily/24 * 4 * (input.system === 'grid' ? 1 : share));
    const inverter = Math.ceil(Math.max(pv / (config.ratio/100),peak*1.25)*10)/10;
    const battery = input.system === 'grid' ? 0 : Math.ceil(daily*share*input.hours/24/(config.usable/100)/(config.discharge/100)*10)/10;
    const inverterProduct = compatible.filter(p=>p.category==='inverter' && p.capacity>=inverter && p.maxPv>=pv).sort((a,b)=>a.capacity-b.capacity)[0] || null;
    const batteries = compatible.filter(p=>p.category==='battery').map(p=>({product:p,quantity:Math.ceil(battery/p.capacity)})).filter(p=>p.quantity>0 && p.quantity<=p.product.maxUnits).sort((a,b)=>a.quantity*a.product.capacity-b.quantity*b.product.capacity);
    const selections = [{category:'panel',product:panel && panels<=panel.maxUnits ? panel:null,quantity:panels},{category:'inverter',product:inverterProduct,quantity:1},{category:'battery',product:battery ? batteries[0]?.product || null:null,quantity:battery ? batteries[0]?.quantity || 0:0}];
    return {daily,share,pvTarget,watts,panels,pv,peak,inverter,battery,selections};
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports={compute}; return; }
  if (customElements.get('grandtech-solar')) return;
  customElements.define('grandtech-solar',class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized=true;
      this.config=JSON.parse(this.querySelector('[data-config]').textContent);
      this.strings=this.config.strings;
      this.form=this.querySelector('form');
      this.fields=this.form.elements;
      this.add=this.querySelector('[data-add]');
      this.options=Array.from(this.querySelectorAll('[data-option]')).flatMap(el=>{const script=el.querySelector('script');return script ? [{...JSON.parse(script.textContent),image:el.querySelector('img')}]:[];});
      this.states={};
      (this.config.states || '').split('|').forEach(row=>{const [code,name,hours]=row.trim().split(':');if(code&&name&&Number(hours)>0&&Number(hours)<=8){this.states[code]=Number(hours);const option=document.createElement('option');option.value=code;option.textContent=name;this.fields.state.append(option);}});
      this.form.addEventListener('submit',e=>{e.preventDefault();this.calculate();});
      this.form.addEventListener('input',()=>this.invalidate());
      this.form.addEventListener('change',()=>{this.sync();this.invalidate();});
      this.form.addEventListener('invalid',()=>{this.querySelector('.sc-advanced').open=true;this.querySelector('[data-status]').textContent=this.strings.invalid;},true);
      this.add.addEventListener('click',()=>this.addToCart());
      this.sync();
    }
    sync() {
      const type=this.fields.system.value;
      this.fields.backup.disabled=type!=='hybrid';
      this.fields.hours.disabled=type==='grid';
      this.querySelector('[data-backup-hint]').textContent=this.strings[type==='grid'?'grid_hint':type==='offgrid'?'offgrid_hint':'backup_hint'];
    }
    invalidate() {
      if (!this.plan) return;
      this.plan=null;
      this.items=[];
      this.add.disabled=true;
      this.querySelector('.sc-plan').hidden=true;
      this.querySelector('.sc-empty').hidden=false;
      this.querySelector('.sc-products').hidden=true;
      this.querySelector('[data-status]').textContent=this.strings.stale;
    }
    calculate() {
      if(!this.form.reportValidity()) return;
      const input={usage:Number(this.fields.usage.value),sun:Number(this.fields.sun.value)||this.states[this.fields.state.value],system:this.fields.system.value,backup:this.fields.backup.value,hours:Number(this.fields.hours.value)||24,peak:Number(this.fields.peak.value)||0};
      try { this.plan=compute(input,this.config,this.options); } catch {this.querySelector('[data-status]').textContent=this.strings.config_error;return;}
      const p=this.plan,s=this.strings;
      this.querySelector('[data-status]').textContent='';
      this.querySelector('[data-cart-status]').textContent='';
      this.querySelector('.sc-empty').hidden=true;
      this.querySelector('.sc-plan').hidden=false;
      this.querySelector('.sc-products').hidden=false;
      for(const [key,value] of Object.entries({pv:`${p.pv.toFixed(2)} kW`,panels:`${p.panels} × ${p.watts} W`,inverter:`${p.inverter.toFixed(1)} kW`,battery:`${p.battery.toFixed(1)} kWh`})) this.querySelector(`[data-metric="${key}"]`).textContent=value;
      this.querySelector('[data-plan-note]').textContent=input.peak?s.entered_peak:s.estimate_peak;
      const assumptions=this.querySelector('[data-assumptions]');assumptions.replaceChildren();
      const rows=[[s.daily,`${p.daily.toFixed(1)} kWh`],[s.assumptions,`${input.sun} ${s.sunlight}`],[s.efficiency,`${this.config.performance}%`],[s.ratio,`${this.config.ratio/100}`],[s.load_share,`${input.system==='grid'?0:p.share*100}%`],[s.duration,`${input.system==='grid'?0:input.hours} ${s.units_hours}`],[s.dod,`${this.config.usable}%`],[s.discharge,`${this.config.discharge}%`]];
      if(input.system==='offgrid') rows.push([s.offgrid_margin,`${this.config.offgridReserve}%`]);
      rows.forEach(([key,value])=>{const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=key;dd.textContent=value;assumptions.append(dt,dd);});
      this.renderProducts();
    }
    renderProducts() {
      const s=this.strings,grid=this.querySelector('[data-products]');grid.replaceChildren();this.items=[];let subtotal=0,currency='USD';
      this.plan.selections.forEach(selection=>{
        const {category,product,quantity}=selection,card=document.createElement('article');card.className='sc-product';
        const kind=document.createElement('p');kind.className='sc-kind';kind.textContent=s[category==='panel'?'panels':category];card.append(kind);
        const title=document.createElement('h3');
        if(product){
          if(product.image) card.append(product.image.cloneNode(true));
          title.textContent=product.title;card.append(title);
          const info=document.createElement('p');info.textContent=`${s.quantity}: ${quantity} · ${s.selected}: ${product.capacity} ${category==='panel'?'W':category==='battery'?'kWh':'kW'}`;card.append(info);
          const link=document.createElement('a');link.className='sc-link';link.href=product.url;link.textContent=s.view;card.append(link);
          const note=document.createElement('p');note.textContent=product.available&&product.single?s.review:s.unavailable;card.append(note);
          if(product.available&&product.single&&product.variant&&quantity>0){this.items.push({id:product.variant,quantity});subtotal+=product.price*quantity;currency=product.currency||'USD';}
        }else{title.textContent=category==='battery'&&!this.plan.battery?s.not_needed:s.missing;card.append(title);}
        grid.append(card);
      });
      const merged=new Map();this.items.forEach(item=>merged.set(item.id,{id:item.id,quantity:item.quantity+(merged.get(item.id)?.quantity||0)}));this.items=Array.from(merged.values());
      this.querySelector('[data-subtotal]').textContent=this.items.length?`${s.total}: ${new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(subtotal/100)}`:s.no_match;
      this.add.disabled=!this.items.length;this.add.textContent=s.add;
    }
    async addToCart() {
      if(this.busy||!this.plan||!this.items.length) return;
      this.busy=true;this.add.disabled=true;this.add.textContent=this.strings.adding;
      const status=this.querySelector('[data-cart-status]');status.textContent='';
      try {
        const response=await fetch(this.config.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:this.items})});
        const result=await response.json();
        if(!response.ok) throw new Error(result.description||this.strings.cart_error);
        status.textContent=this.strings.added;
        this.add.textContent=this.strings.added;
      } catch(error){status.textContent=`${this.strings.cart_error} ${error.message===this.strings.cart_error?'':error.message}`;this.add.textContent=this.strings.add;}
      finally {this.busy=false;this.add.disabled=true;}
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
